import type { FeatureBlockData } from '@af/design-system-docs-ui/feature-block-grid';

import modeDelegateDark from '../_assets/mode-delegate-dark.png';
// oxlint-disable import/extensions -- PNG imports require explicit extension
import modeDelegate from '../_assets/mode-delegate.png';
import modeMultiDark from '../_assets/mode-multiplayer-dark.png';
import modeMulti from '../_assets/mode-multiplayer.png';
import modeCollabDark from '../_assets/mode-paired-dark.png';
import modeCollab from '../_assets/mode-paired.png';
import modeSingleDark from '../_assets/mode-single-dark.png';
import modeSingle from '../_assets/mode-single.png';
import flowDark from '../_assets/Principle-flow-dark.png';
import flow from '../_assets/Principle-flow.png';
import syncAsyncDark from '../_assets/Principle-harmony-dark.png';
import syncAsync from '../_assets/Principle-harmony.png';
import humanAgencyDark from '../_assets/Principle-human-dark.png';
import humanAgency from '../_assets/Principle-human.png';
import proliferationDark from '../_assets/Principle-profil-dark.png';
import proliferation from '../_assets/Principle-profil.png';
import multiplayerScaleDark from '../_assets/Principle-scale-dark.png';
import multiplayerScale from '../_assets/Principle-scale.png';
import multiVendorDark from '../_assets/Principle-vendor-dark.png';
import multiVendor from '../_assets/Principle-vendor.png';

export const experiences: FeatureBlockData[] = [
	{
		title: 'Agent proliferation',
		description: 'There will increasingly be more agents and agent actions at work.',
		image: { src: proliferation, srcDark: proliferationDark, alt: '' },
	},
	{
		title: 'Experience of flow',
		description:
			'Creating an experience of flow is critical when working across diverse tools and workflows.',
		image: { src: flow, srcDark: flowDark, alt: '' },
	},
	{
		title: 'Multi-vendor ecosystem',
		description:
			'Customers will always operate across multiple vendors (Graphs, Models, Apps, and Connectors).',
		image: { src: multiVendor, srcDark: multiVendorDark, alt: '' },
	},
	{
		title: 'Human agency & accountability',
		description: 'Humans must play the pivotal role in transparency, accountability, and judgment.',
		image: { src: humanAgency, srcDark: humanAgencyDark, alt: '' },
	},
	{
		title: 'Multiplayer at scale',
		description:
			'The multiplayer case is a critical one to solve for organizations (from one team to a team-of-teams).',
		image: { src: multiplayerScale, srcDark: multiplayerScaleDark, alt: '' },
	},
	{
		title: 'Sync & async harmony',
		description:
			'Workflows will inherently balance both synchronous and asynchronous collaboration.',
		image: { src: syncAsync, srcDark: syncAsyncDark, alt: '' },
	},
];

export const interactionModes: FeatureBlockData[] = [
	{
		title: 'Single player',
		description:
			'Humans will continue to work solo but will still need to understand collaboration patterns, when reviewing work coming from other modes.',
		image: {
			src: modeSingle,
			srcDark: modeSingleDark,
			alt: 'Single-player mode: Liam works alone on a shared canvas, represented by a named cursor and a circular avatar.',
		},
	},
	{
		title: 'Delegation',
		description:
			'The simplest human-agent interaction will be delegating work for an agent to complete.',
		image: {
			src: modeDelegate,
			srcDark: modeDelegateDark,
			alt: 'Delegation mode: Claude works on an assigned Jira item, with its progress shown beneath the card.',
		},
	},
	{
		title: 'Paired collaboration',
		description: 'Humans can collaborate 1:1 with an agent to get work done as a partnership.',
		image: {
			src: modeCollab,
			srcDark: modeCollabDark,
			alt: 'Paired mode: Liam asks the Planner agent to map out next steps, and the agent shows that it is thinking.',
		},
	},
	{
		title: 'Multiplayer',
		description:
			'The most complex but most rewarding mode is true multiplayer, with many humans and agents working as one coherent team.',
		image: {
			src: modeMulti,
			srcDark: modeMultiDark,
			alt: 'Multiplayer mode: two people and two agents edit a shared plan, with named cursors identifying each participant.',
		},
	},
];
